/* tslint:disable */
/* eslint-disable */
// @ts-ignore
import * as Types from '../../../../../global-graphql-types'

import { DocumentNode } from 'graphql'
import * as Apollo from '@apollo/client'
import * as ApolloReactHooks from 'utils/extendApolloHooks'
const defaultOptions = {} as const
export type EmailVerificationCodeVerifyVariables = Types.Exact<{
  email: Types.Scalars['String']
  code: Types.Scalars['String']
}>

export type EmailVerificationCodeVerify = {
  __typename: 'Root'
  emailVerificationCodeVerify: {
    __typename: 'EmailVerificationCodeVerifyPayload'
    emailToken: string | null
    errors: Array<{
      __typename: 'UserError'
      fullMessage: string | null
      key: string | null
      message: string | null
    }> | null
  } | null
}

export const EmailVerificationCodeVerifyDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'EmailVerificationCodeVerify' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'email' }
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'code' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
          }
        }
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'emailVerificationCodeVerify' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'email' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'email' }
                }
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'code' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'code' }
                }
              }
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'emailToken' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'errors' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'fullMessage' }
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'message' }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
} as unknown as DocumentNode
export type EmailVerificationCodeVerifyMutationFn = Apollo.MutationFunction<
  EmailVerificationCodeVerify,
  EmailVerificationCodeVerifyVariables
>

/**
 * __useEmailVerificationCodeVerify__
 *
 * To run a mutation, you first call `useEmailVerificationCodeVerify` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmailVerificationCodeVerify` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emailVerificationCodeVerify, { data, loading, error }] = useEmailVerificationCodeVerify({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useEmailVerificationCodeVerify(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    EmailVerificationCodeVerify,
    EmailVerificationCodeVerifyVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useMutation<
    EmailVerificationCodeVerify,
    EmailVerificationCodeVerifyVariables
  >(EmailVerificationCodeVerifyDocument, options)
}
export type EmailVerificationCodeVerifyHookResult = ReturnType<
  typeof useEmailVerificationCodeVerify
>
export type EmailVerificationCodeVerifyMutationResult =
  Apollo.MutationResult<EmailVerificationCodeVerify>
export type EmailVerificationCodeVerifyMutationOptions =
  Apollo.BaseMutationOptions<
    EmailVerificationCodeVerify,
    EmailVerificationCodeVerifyVariables
  >
